import React, { useState } from 'react';
import './FirstLoginPasswordModal.css';

function FirstLoginPasswordModal({ onChangePassword }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [error, setError] = useState('');
  const [pending, setPending] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (!newPassword) {
      setError('새 비밀번호를 입력하세요.');
      return;
    }
    if (newPassword !== confirmation) {
      setError('새 비밀번호가 일치하지 않습니다.');
      return;
    }
    if (currentPassword === newPassword) {
      setError('새 비밀번호는 현재 비밀번호와 달라야 합니다.');
      return;
    }
    setPending(true);
    try {
      await onChangePassword(currentPassword, newPassword);
    } catch (err) {
      setError(err?.message || '비밀번호 변경에 실패했습니다.');
    } finally {
      setPending(false);
    }
  };

  return (
    <div className="first-login-overlay">
      <section className="first-login-modal" role="dialog" aria-modal="true" aria-labelledby="first-login-title">
        <header>
          <span className="first-login-badge">SECURITY REQUIRED</span>
          <h2 id="first-login-title">최초 로그인 비밀번호 변경</h2>
          <p>임시 비밀번호로 로그인했습니다. 계속하려면 본인만 아는 새 비밀번호로 변경하세요.</p>
        </header>
        <form onSubmit={handleSubmit}>
          <label htmlFor="first-login-current">현재 임시 비밀번호</label>
          <input id="first-login-current" type="password" autoComplete="current-password" value={currentPassword} onChange={(event) => setCurrentPassword(event.target.value)} required autoFocus />
          <label htmlFor="first-login-new">새 비밀번호</label>
          <input id="first-login-new" type="password" autoComplete="new-password" value={newPassword} onChange={(event) => setNewPassword(event.target.value)} required />
          <label htmlFor="first-login-confirm">새 비밀번호 확인</label>
          <input id="first-login-confirm" type="password" autoComplete="new-password" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} required />
          <small>현재 임시 비밀번호와 다르게 입력</small>
          {error && <div className="first-login-error" role="alert">{error}</div>}
          <button type="submit" disabled={pending}>{pending ? '변경 중...' : '비밀번호 변경'}</button>
        </form>
      </section>
    </div>
  );
}

export default FirstLoginPasswordModal;
